// src/components/settings/shared/SettingsAccordionElements.tsx
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import { color, fontSize } from '@mui/system';

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[900]}`,
  margin: 0,
  '&:not(:last-child)': {
    marginBottom: 0,
  },
  '&.Mui-expanded': {
    margin: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

interface StyledAccordionSummaryProps {
  isOdd?: boolean;
}

export const StyledAccordionSummary = styled(AccordionSummary, {
  shouldForwardProp: (prop) => prop !== 'isOdd',
})<StyledAccordionSummaryProps>(({ theme, isOdd }) => {
  const isDark = theme.palette.mode === 'dark';
  const tint = isDark
    ? theme.palette.tertiary.light
    : theme.palette.tertiary.main;

  const backgroundColor =
    isOdd !== undefined
      ? isOdd
        ? alpha(tint, isDark ? 0.14 : 0.7)
        : alpha(tint, isDark ? 0.06 : 0.5)
      : isDark
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.02)';

  return {
    backgroundColor,
    '&:hover': {
      backgroundColor: theme.palette.tertiary.dark,
      '& p': {
        color: theme.palette.grey[0],
      },
    },
    '&.Mui-expanded': {
      minHeight: 'auto',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '12px 0',
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      color: theme.palette.grey[0],
      transition: 'transform 0.2s ease',
      '& svg': {
        fill: theme.palette.grey[0],
        fontSize: '3rem',
      },
      '&:hover': {
        transform: 'scale(2)',
      },
    },
  };
});

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: '16px 0 0 0',
  borderTop: `1px solid ${theme.palette.divider}`,
  borderBottom: `1px solid ${theme.palette.primary.dark}`,
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.02)'
      : 'rgba(0, 0, 0, 0.01)',
}));
